import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import { useState } from "react";
import { Project } from "../../../../types";
import { Button } from "../../../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../ui/dropdown-menu";
import { PageHeader } from "../../../ui/page-header";
import { EditProjectDialog } from "../../EditProjectDialog";
import { ProjectEnvironmentSelector } from "../../ProjectEnvironmentSelector";

interface ProjectDetailsHeaderProps {
  project: Project;
  onEnvironmentChange: (environment: any) => void;
  onProjectUpdated?: () => void;
  onDeleteClick?: () => void;
}

export function ProjectDetailsHeader({
  project,
  onEnvironmentChange,
  onProjectUpdated,
  onDeleteClick,
}: ProjectDetailsHeaderProps) {
  const [editOpen, setEditOpen] = useState(false);

  return (
    <PageHeader
      eyebrow="Project"
      title={project.name}
      description={project.description}
      actions={
      <>
        <ProjectEnvironmentSelector onEnvironmentChange={onEnvironmentChange} />

        <EditProjectDialog
          project={project}
          onProjectUpdated={onProjectUpdated}
          open={editOpen}
          onOpenChange={setEditOpen}
        />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="icon" aria-label="Project actions">
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil className="mr-2 h-4 w-4" />
              Edit project
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="text-destructive focus:text-destructive"
              onClick={onDeleteClick}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Delete project
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </>
      }
    />
  );
}
